import React, {useContext, useEffect, useState} from 'react';
import Title from "antd/es/typography/Title";
import {useNavigate} from "react-router-dom";
import {BackendContext} from "../../../App";
import {Paths} from "../../../Paths";
import ClearBody from "../../../components/ClearBody";
import {Button, Modal, notification, Spin, Switch} from "antd";
import {Messages} from "../../../backend/Messages";
import {StatusCodes} from "../../../backend/StatusCodes";

type NotificationType = 'success' | 'info' | 'warning' | 'error';


function SetRunningValuesPage() {
  const backendContext = useContext(BackendContext);
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [debugFlag, setDebugFlag] = useState(false);

  const openNotificationWithIcon = (type: NotificationType, title: string, description: string) => {
    api[type]({
      message: title,
      description: description,
    });
  };

  useEffect(() => {
    if (! backendContext.hasPlayerAuth()) {
      navigate(Paths.LoginSteamPage);
    }
  }, [backendContext, navigate]);

  const clickedSetNewValues = () => {
    setIsModalOpen(true);
    backendContext.setServerRunningValues(debugFlag).then((commonResponse) => {
      setIsModalOpen(false);
      console.log("Error: " + commonResponse.isError);
      if (commonResponse.isError) {
        openNotificationWithIcon("error", "Error", commonResponse.description);
        return;
      }

      openNotificationWithIcon("success", "Success", commonResponse.description);

    }).catch((error) => {

      setIsModalOpen(false);
      openNotificationWithIcon("error", Messages.UnknownErrorTitle, Messages.UnknownErrorDescription + " " + JSON.stringify(error));
    });
  }

  return (
    <>
      {contextHolder}
      <ClearBody content={
        <div>
          <Title>Set running values</Title>
          <br />
          <Switch
            checked={debugFlag}
            checkedChildren="Debug will be enabled"
            unCheckedChildren="Debug will be disabled"
            onChange={(checked) => {
                setDebugFlag(checked);
              }
            }
          />

          <br />
          <br />
          <Button type="primary" onClick={clickedSetNewValues}>Set new values</Button>

          <Modal open={isModalOpen} centered={true} closable={false}
                 okButtonProps={{ style: { display: 'none' } }}
                 cancelButtonProps={{ style: { display: 'none' } }}
          >
            <div style={{textAlign: "center"}}>
              <Spin size="large" />
            </div>
          </Modal>

        </div>
      } />
    </>
  );
}

export default SetRunningValuesPage;